export default __webpack_public_path__ + "static/media/insomnia.769773eb.png";